import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoldloancompletedlistService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/goldloancompletedlist";

  searchGoldloancompletedlistReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": null
      
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition/Completed${queryParams}`, requestBody);
  }

  getTotalEligibleAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Completed/totalEligibleLoanAmount`, requestBody);
  }

    getTotalInterestAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Completed/totalInterestAmount`, requestBody);
  }

    getTotalLoanAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Completed/totalLoanAmount`, requestBody);
  }

}
